import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { FiPlus } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

import Pagination from 'components/Pagination';
import Button from 'components/Button';
import NotFound from 'components/NotFound';
import Loader from 'components/ContentLoader/GenericLoader';
import Avatar from 'components/Avatar';
import Card from 'components/Card';

import NoSolicitacaoChamada from 'assets/Fill out-pana.svg';
import api from 'services/api';
import AppError from 'utils/AppError';
import { Usuario } from 'pages/@types';

import { Table } from 'styles/global';
import { Container } from './styles';
export interface ISugestaoPauta {
  id: number;
  titulo: string;
  pautainfo: string;
  programa: string;
  solicitante: Usuario;
}

export default function SugestaoPauta() {
  // react-router-dom
  const navigate = useNavigate();
  /**
   * USE STATE
   */
  const [sugestoes, setSugestoes] = useState<ISugestaoPauta[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);

  // const handleNovaSugestao = useCallback(() => {
  //   navigate('/sugestaopauta/novo');
  // }, []);

  /**
   * USE EFFECT
   */
  useEffect(() => {
    const controller = new AbortController();
    async function loadSugestao() {
      setLoading(true);
      try {
        const response = await api.get('/sugestaopauta', {
          signal: controller.signal,
          params: {
            page,
          },
        });
        if (response && response.data) {
          setPages(response.data.pages);
          setSugestoes(response.data.sugestoes);
        } else toast.error('Falha de comunicação com o servidor');
      } catch (e) {
        if (e instanceof Error) toast.error(e.message);
        else if (e instanceof AppError) toast.error(e.message);
        else {
          const appError = e as AppError;
          if (appError.message) toast.error(appError.message);
          else toast.error('Erro inesperado');
        }
      }
      setLoading(false);
    }
    loadSugestao();
    return () => {
      controller.abort();
    };
  }, [page]);

  return (
    <Container>
      <Card>
        <header style={{ alignItems: 'baseline' }}>
          <h4>LISTA DE SUGESTÕES DE PAUTAS</h4>
          <Pagination
            total={pages}
            activePage={page}
            onClick={page => setPage(page)}
          />
          <Button
            color="primary"
            href={'/sugestaopauta/novo'}
            tooltip="Criar nova Sugestão de Pauta"
          >
            CRIAR NOVA SUGESTÃO
            <FiPlus />
          </Button>
        </header>
        {loading ? (
          <Loader />
        ) : !!sugestoes && sugestoes.length ? (
          <div style={{ padding: `0 15px` }}>
            <Table>
              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>TITULO</th>
                  <th style={{ width: '40rem', textAlign: 'left' }}>
                    PROGRAMA
                  </th>
                  <th style={{ textAlign: 'center' }}>SOLICITANTE</th>
                </tr>
              </thead>
              <tbody>
                {sugestoes.map(s => (
                  <tr key={s.id}>
                    <td>{s.titulo}</td>
                    <td style={{ textAlign: 'left' }}>{s.programa}</td>
                    <td style={{ width: '10rem', textAlign: 'center' }}>
                      <Avatar
                        size="40"
                        name={s.solicitante?.nome}
                        src={s.solicitante?.avatar_url}
                        round
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <NotFound img={NoSolicitacaoChamada} title="Sugestão Pauta">
            Nenhuma Sugestão de Pauta encontrada
          </NotFound>
        )}
      </Card>
    </Container>
  );
}
